import { render } from "./UiFormError.vue?vue&type=template&id=481e9cc9"
import script from "./UiFormError.vue?vue&type=script&lang=js"
export * from "./UiFormError.vue?vue&type=script&lang=js"

import exportComponent from "D:\\laragon\\www\\leader-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__